<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>
              {{ `${this.$t("bills.view.title")}` }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-3"
              color="secondary"
              :to="'/societyadmin/bills/edit/' + bill.id"
            >
              <v-icon small left>
                mdi-pencil
              </v-icon>
              Edit
            </v-btn>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("notice.view.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text--primary">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.type")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ getType(bill.type) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.title")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ bill.title }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.description")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.description }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.amount")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.amount }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{
                          `${this.$t("bills.view.headers.amount_for_rental")}`
                        }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.amount_for_rental }}
                    </v-col>
                  </v-row>
                  <v-row v-if="bill.type == 2 || bill.type == 3">
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.day_of_month")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.day_of_month }}
                    </v-col>
                  </v-row>
                  <v-row v-if="bill.type == 3">
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.month")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.month }}
                    </v-col>
                  </v-row>
                  <v-row v-if="bill.type == 1">
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{
                          `${this.$t("bills.view.headers.one_time_date")}`
                        }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ getFormattedDate(bill.one_time_date) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{
                          `${this.$t("bills.view.headers.due_days")}`
                        }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ bill.due_days }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >Due Date
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      {{ calculateDueDate() }}
                    </v-col>
                  </v-row>
                    <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("bills.view.headers.documents")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="9">
                      <v-row v-if="bill.documents.length > 0">
                        <v-col
                          v-for="item in bill.documents"
                          :key="item.document_url"
                          class="d-flex child-flex"
                          cols="6"
                          sm="6"
                          md="3"
                        >
                          <v-card>
                            <v-img
                              v-if="item.file_type == 'image'"
                              :src="
                                API_BASE_URL + '/uploads/' + item.document_url
                              "
                              :lazy-src="
                                API_BASE_URL + '/uploads/' + item.document_url
                              "
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-img
                              v-else
                              :src="API_BASE_URL + '/default-pdf.png'"
                              :lazy-src="API_BASE_URL + '/default-pdf.png'"
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-btn
                              icon
                              color="secondary"
                              name="view_notice"
                              title="Edit "
                              @click="openDocument(item)"
                              style="float: right"
                            >
                              <v-icon small v-if="item.file_type == 'image'">
                                mdi-eye</v-icon
                              >
                              <v-icon small v-else> mdi-eye</v-icon>
                            </v-btn>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col>
                          <span>No Documents Available</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold">
                        {{ `${this.$t("bills.view.headers.send_to")}` }} :
                      </span>
                    </v-col>
                    
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted">
                      <p class="secondary white--text px-3 rounded-xl py-2 text-center font-weight-medium">{{ `${ bill.flat_id ? bill.flat.name : '' } ${send_to_types[bill.send_to]} Members` }}</p>
                      <v-row class="d-flex">
                        <v-col cols="6" sm="6" md="3" v-for="member in bill.members" :key="member.id" class="align-self-stretch">
                          <v-card class="text-center pt-5 pb-5 elevation-3" height="100%">
                            <v-card-text>
                              <span class="text-body-1 black--text font-weight-medium">{{ member.house_number }}</span>
                              <div :style="{ border: '1px solid grey', marginTop:'20px', marginBottom: '20px' }"></div>
                              <span class="text-body-1 font-weight-medium">{{ member.name }}</span>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      bill: {
        title: "",
        description: "",
        type: "",
        amount: "",
        amount_for_rental: "",
        day_of_month: "",
        month: "",
        one_time_date: "",
        date: "",
        documents: "",
        due_days: "",
        send_to: "",
      },
      base_url: process.env.VUE_APP_API_URL,
      types: [
        {
          text: "One Time",
          value: 1,
        },
        {
          text: "Monthly",
          value: 2,
        },
        {
          text: "Yearly",
          value: 3,
        },
      ],
      send_to_types: {
        1: 'All',
        2: 'Flat',
        3: 'Single Houses'
      }
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getBillDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/bills/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.bill = data.bill;
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    calculateDueDate() {
      const { one_time_date, due_days } = this.bill;
      if (one_time_date && due_days) {
        return moment(one_time_date).add(due_days, 'days').format("DD-MM-YYYY");
      }
      return "N/A";
    },
    getType(type) {
      let item = this.types.find((t) => {
        return t.value == type;
      });

      return item ? item.text : "N/A";
    },
    openDocument(item) {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getBillDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.pre-formatted {
  white-space: pre-line !important;
}
</style>
